import { Link } from "react-router-dom";

const SaleOrderLink = ({ soId, children }) => {

    return (
        <Link to={`/workspace/sales/so/${soId}`}>{children}</Link>
    )
}

export default SaleOrderLink;